import { useState } from "react";
import { withRouter } from "react-router-dom";

import "../assets/css/partnerPortal/appDeveloper.scss";
import ButtonArrow from "./ButtonArrow";

function CardWithNoBorder(props) {
  const [title] = useState(props.title);
  const [subTitle] = useState(props.subTitle);
  const [icon] = useState(props.icon);
  const [eyeBrow] = useState(props.eyeBrow);
  const [contentStart] = useState(props.contentStart);
  const [imageWidth] = useState(props.imageWidth);
  const [link] = useState(props.link);
  const [linkOpenSamePage] = useState(props.linkOpenSamePage);
  const [linkForTitle] = useState(props.linkForTitle);
  const [maxWidth] = useState(props.maxWidth);
  const [imageHeight] = useState(props.imageHeight);
  const [margin] = useState(props.margin);

  return (
    <>
      <div className={"cardCol" + (contentStart ? " align-items-start" : "")}>
        {link ? (
          <a href={link} target={linkOpenSamePage ? "_parent" : "_blank"}>
            {eyeBrow === "" ? (
              <img
                className="mb-0"
                style={{
                  maxWidth: maxWidth ? maxWidth : "",
                  height: imageHeight ? imageHeight : "",
                  margin: margin ? margin : "",
                }}
                src={icon}
                alt="..."
                width={imageWidth ? imageWidth : "100%"}
                object-fit="contain"
                object-position="center"
              />
            ) : (
              icon && (
                <img
                  src={icon}
                  style={{
                    maxWidth: maxWidth ? maxWidth : "",
                    height: imageHeight ? imageHeight : "",
                    margin: margin ? margin : "",
                  }}
                  width={imageWidth ? imageWidth : "100%"}
                  object-fit="contain"
                  object-position="center"
                  alt="..."
                />
              )
            )}
          </a>
        ) : eyeBrow === "" ? (
          <img
            className="mb-3"
            src={icon}
            alt="..."
            width={imageWidth ? imageWidth : ""}
            object-fit="contain"
            object-position="center"
          />
        ) : (
          icon && (
            <img
              src={icon}
              width={imageWidth ? imageWidth : "100%"}
              alt="..."
              object-fit="contain"
              object-position="center"
            />
          )
        )}

        {eyeBrow === "" ? (
          ""
        ) : (
          <div
            className={
              "smallerEyebrowHeader mt-4 mb-2 " +
              (contentStart ? "justify-content-start " : "")
            }
          >
            {eyeBrow}
          </div>
        )}
        <div
          className={
            "cardColText " + (contentStart ? "justify-content-start " : "")
          }
        >
          {linkForTitle && link ? (
            <ButtonArrow link={link} buttonName={title} />
          ) : (
            title
          )}
        </div>
        <div
          className={
            "cardColSubText " +
            (contentStart ? "justify-content-start text-left " : "")
          }
        >
          {subTitle}
        </div>
      </div>
    </>
  );
}

export default withRouter(CardWithNoBorder);
